function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.23 119.8h.19a1.5 1.5 0 000-3H88.6a1.5 1.5 0 000 3h.18l-4.92 7.34V194l3.92 8.12h39.45l3.91-8.12v-66.9zm-33.85 0h30.25l2.9 4.34h-36zm31.17 23.63v34.31h-32.1v-34.31zm1.8 55.73H89.66l-1-2.12h37.72z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 215 215"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/can-small.svg";
export { SvgComponent as ReactComponent };